/**
 * `slug:` optional filter on the `locations` index uses the hit `slug` (region-only when URL is `region--city`).
 */
export const localitySlugForAlgoliaOptionalFilter = (raw?: string): string => {
  if (!raw) return ''
  if (!raw.includes('--')) return raw
  return raw.split('--')[0] ?? ''
}

/**
 * `filters.location` / route param may be composite `region--city` from the URL.
 * Algolia location hits often use `slug` = region only (left segment before `--`).
 */
export const localitySlugMatchesFilter = (
  locationHitSlug: string,
  filterLocation?: string
): boolean => {
  if (!filterLocation) return false
  if (locationHitSlug === filterLocation) return true
  if (filterLocation.includes('--')) {
    return locationHitSlug === filterLocation.split('--')[0]
  }
  return false
}
